import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {isLoggedIn} from './Auth';
import Drawer from "./components/drawer";

export const PrivateRoute = ({component: Component, ...rest}) => {
    return (

        // Show the component only when the user is logged in
        // Otherwise, redirect the user to /signin page
        <Route {...rest} render={props => (
            isLoggedIn() ?
                <div className="App">
                    <Drawer/>
                    <Component {...props} />
                </div>
                : <Redirect to="/"/>
        )}/>
    );
};
